import * as Yup from "yup";


export const qcpSchemaTest1 = Yup.object({
    batchNo: Yup.string().required("Enter Batch Number"),
    boxNo: Yup.string().required("Enter Box Number"),
    quality: Yup.string().required("Select Product Quality"),
    weight: Yup.string().required("Select Weight"),
    smell: Yup.string().required("Select Smell"),
    quantity: Yup.string().required("Select Quantity"),
    labelInfo: Yup.string().required("Select Label Info"),
    packaging: Yup.string().required("Select Packaging"),
    description: Yup.string().required("Enter Description"),
    type: Yup.string().required("Select Test Type"),
    status: Yup.string().required("Select Status"),
    // melanin: Yup.string().required("Enter Melanin"),
    // bloodSpot: Yup.string().required("Enter BloodSpot"),
    // whiteSpots: Yup.string().required("Enter WhiteSpots"),
    // cartilage: Yup.string().required("Enter Cartilage"),
    // gaping: Yup.string().required("Enter Gaping"),
    // deformed: Yup.string().required("Enter Deformed"),
    // skinWounds: Yup.string().required("Enter Skin Wounds"),

    approvedBy: Yup.string().required("Select Approved By"), // Corrected field name
    temperature: Yup.number()
        .required("Enter Temp") // Check for required first
        .typeError("Enter a valid temperature (numeric) between -20 and +10") // Ensure the correct error message for non-numeric input
        .min(-20, "Temp should not be less than -20") // Minimum value validation
        .max(10, "Temp should not be greater than +10"), // Maximum value validation
    // pieces: Yup.number()
    //     .required("Enter Pieces") // Check for required first
    //     .typeError("Enter Pieces") // Ensure the correct error message for non-numeric input
    //     .min(0, "Enter valid Pieces"), // Validate minimum value
    // grossKg: Yup.number()
    //     .required("Enter GrossKg") // Check for required first
    //     .typeError("Enter GrossKg") // Ensure the correct error message for non-numeric input
    //     .min(0, "Enter valid Amount"), // Validate minimum value
})

export const qcpSchemaTest2 = Yup.object({
    batchNo: Yup.string().required("Enter Batch Number"),
    boxNo: Yup.string().required("Enter Box Number"),
    status: Yup.string().required("Select Status"),

    // quality: Yup.string().required("Select Product Quality"),
    // weight: Yup.string().required("Select Weight"),
    // smell: Yup.string().required("Select Smell"),
    // quantity: Yup.string().required("Select Quantity"),
    // labelInfo: Yup.string().required("Select Label Info"),
    // packaging: Yup.string().required("Select Packaging"),
    description: Yup.string().required("Enter Description"),
    type: Yup.string().required("Select Test Type"),

    melanin: Yup.string().required("Enter Melanin"),
    bloodspot: Yup.string().required("Enter BloodSpot"),
    whiteSpots: Yup.string().required("Enter WhiteSpots"),
    cartilage: Yup.string().required("Enter Cartilage"),
    gaping: Yup.string().required("Enter Gaping"),
    deformed: Yup.string().required("Enter Deformed"),
    skinWounds: Yup.string().required("Enter Skin Wounds"),

    approvedBy: Yup.string().required("Select Approved By"), // Corrected field name
    temperature: Yup.number()
        .required("Enter Temp") // Check for required first
        .typeError("Enter a valid temperature (numeric) between -20 and +10") // Ensure the correct error message for non-numeric input
        .min(-20, "Temp should not be less than -20") // Minimum value validation
        .max(10, "Temp should not be greater than +10"), // Maximum value validation
    // pieces: Yup.number()
    //     .required("Enter Pieces") // Check for required first
    //     .typeError("Enter Pieces") // Ensure the correct error message for non-numeric input
    //     .min(0, "Enter valid Pieces"), // Validate minimum value
    // grossKg: Yup.number()
    //     .required("Enter GrossKg") // Check for required first
    //     .typeError("Enter GrossKg") // Ensure the correct error message for non-numeric input
    //     .min(0, "Enter valid Amount"), // Validate minimum value
})